import Vue from 'vue'
import Vuex from 'vuex'

import restaurant from './restaurant'
import branch from './branch'
import menu from './menu'
import cart from './cart'
import order from './order'
import auth from './auth'
import map from './map'
import dialog from './dialog'
import card from './card'
import preorder from './preorder'
import lang from './lang'
import loading from './loading'
import line from './line'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    branch: branch,
    menu: menu,
    cart: cart,
    order: order,
    auth: auth,
    map: map,
    restaurant: restaurant,
    dialog: dialog,
    card: card,
    preorder: preorder,
    lang: lang,
    loading: loading,
    line: line
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js